import * as moment from "moment";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import {
  formatarProgramacaoRevisao,
  mergeProgramacaoSlide,
  montarProgramacaoPayload,
  validarProgramacaoSlides
} from "./carrossel-slide-programacao";

export const carrossel_types = {
  CARROSSEL_PRODUTOS: "CARROSSEL_PRODUTOS",
  CARROSSEL_PRODUTOS_CLIENTE: "CARROSSEL_PRODUTOS_CLIENTE",
  CARROSSEL_PRODUTOS_NOVOS: "CARROSSEL_PRODUTOS_NOVOS",
  CARROSSEL_LISTA_COMPRAS: "CARROSSEL_LISTA_COMPRAS"
};

export const carrossel_types_list = {
  type1: [
    {
      text: "Vitrine de produtos",
      value: "CARROSSEL_PRODUTOS"
    },
    {
      text: "Vitrine de produtos mais comprados pelo cliente",
      value: "CARROSSEL_PRODUTOS_CLIENTE"
    },
    {
      text: "Vitrine de lista de compras",
      value: "CARROSSEL_LISTA_COMPRAS"
    },
    {
      text: "Vitrine de novos produtos",
      value: "CARROSSEL_PRODUTOS_NOVOS"
    }
  ],
  type2: [
    {
      text: "Vitrine de produtos",
      value: "CARROSSEL_PRODUTOS"
    },
    {
      text: "Vitrine de novos produtos",
      value: "CARROSSEL_PRODUTOS_NOVOS"
    }
  ]
};

const LOCAL_BASE_OPTIONS = [
  { text: "Lista inicial de produtos", value: "page:home" },
  { text: "Detalhes de produto", value: "page:product-details" },
  { text: "Todas as páginas", value: "page:all" },
  { text: "Página estática", value: "page:static-page" }
];

export const LOCAL_CATEGORIA_SENTINEL = "page:categoria";

export const getSetorId = (setor = {}) => setor.idsetor || setor.id;

export const getCategoriaLocalOptions = (setoresFolha = []) =>
  (setoresFolha || []).map(setor => ({
    text: setor.rotulo || setor.descricao || setor.nome,
    value: `categoria:${getSetorId(setor)}`
  }));

export const getLocalExibicaoBaseOptions = (setoresFolha = []) => {
  const options = [{ text: "Todos", value: "" }].concat(LOCAL_BASE_OPTIONS);

  if (getCategoriaLocalOptions(setoresFolha).length) {
    options.push({ text: "Categoria", value: LOCAL_CATEGORIA_SENTINEL });
  }

  return options;
};

export const getLocalExibicaoOptions = (setoresFolha = []) => {
  return getLocalExibicaoBaseOptions(setoresFolha)
    .filter(option => option.value !== LOCAL_CATEGORIA_SENTINEL)
    .concat(getCategoriaLocalOptions(setoresFolha));
};

export const getStatusFilterOptions = () => [
  { text: "Todos", value: null },
  { text: "Ativo", value: true },
  { text: "Inativo", value: false }
];

export const getListagemColumns = tipoConteudo => {
  const isStatic = tipoConteudo === "STATIC_IMAGES";
  const columns = [];

  if (isStatic) {
    columns.push({
      text: "Carrossel",
      value: "titulo",
      sortable: false
    });
  } else {
    columns.push({
      text: "Vitrine",
      value: "titulo",
      sortable: false
    });
  }

  columns.push(
    { text: "Local de exibição", value: "local", sortable: false },
    { text: "Período de vigência", value: "vigencia", sortable: false }
  );

  if (isStatic) {
    columns.push({ text: "Banners", value: "banners", sortable: false });
  } else {
    columns.push({
      text: "Categoria / tipo",
      value: "categoriaTipo",
      sortable: false
    });
  }

  columns.push(
    { text: "Status", value: "status", sortable: false, align: "center" },
    {
      text: "Ações",
      value: "acoes",
      sortable: false,
      align: "center",
      width: 120
    }
  );

  return columns;
};

const normalizeLocalValue = local => {
  if (!local) return "";
  if (typeof local === "string") {
    const pipeIndex = local.indexOf("|");
    return pipeIndex > 0 ? local.substring(0, pipeIndex) : local;
  }
  if (local.value) {
    const pipeIndex = local.value.indexOf("|");
    return pipeIndex > 0 ? local.value.substring(0, pipeIndex) : local.value;
  }
  return "";
};

const resolveCategoriaLabel = (localValue, setoresFolha = []) => {
  if (!localValue.startsWith("categoria:")) {
    return null;
  }

  const categoriaId = localValue.replace("categoria:", "");
  const setor = (setoresFolha || []).find(
    item => getSetorId(item) === categoriaId
  );

  return setor ? setor.rotulo || setor.descricao || setor.nome : null;
};

export const formatLocalExibicao = (localexibicao = [], setoresFolha = []) => {
  const locais = Array.isArray(localexibicao) ? localexibicao : [];
  if (!locais.length) {
    return "Não definido";
  }

  const options = getLocalExibicaoOptions(setoresFolha).filter(o => o.value);
  const labels = locais.map(local => {
    const localValue = normalizeLocalValue(local);
    const found = options.find(
      o => o.value === localValue || localValue.startsWith(o.value)
    );
    if (found) {
      return found.text;
    }

    const categoriaLabel = resolveCategoriaLabel(localValue, setoresFolha);
    if (categoriaLabel) {
      return categoriaLabel;
    }

    if (localValue.startsWith("categoria:")) {
      return localValue.replace("categoria:", "Categoria ");
    }

    return localValue || local;
  });

  return labels.join(", ");
};

export const formatVigencia = (inicio, fim) => {
  if (!inicio && !fim) {
    return "—";
  }

  const inicioFmt = inicio ? moment(inicio).format("DD/MM/YYYY") : "—";
  const fimFmt = fim ? moment(fim).format("DD/MM/YYYY") : "—";

  return `${inicioFmt} a ${fimFmt}`;
};

export const formatCarouselTypeLabel = (carouselType, variant = "type1") => {
  if (!carouselType) {
    return "—";
  }

  const list = carrossel_types_list[variant] || carrossel_types_list.type1;
  const found = list.find(item => item.value === carouselType);
  return found ? found.text : carouselType;
};

export const getCarouselTypeValue = tipo => {
  if (!tipo) {
    return null;
  }
  if (typeof tipo === "object" && tipo.value) {
    return tipo.value;
  }
  return tipo;
};

export const isCarrosselProdutos = carouselType => {
  const value = getCarouselTypeValue(carouselType);
  return !value || value === carrossel_types.CARROSSEL_PRODUTOS;
};

export const isCarrosselProdutosCliente = carouselType => {
  return (
    getCarouselTypeValue(carouselType) ===
    carrossel_types.CARROSSEL_PRODUTOS_CLIENTE
  );
};

export const isCarrosselListaCompras = carouselType => {
  return (
    getCarouselTypeValue(carouselType) ===
    carrossel_types.CARROSSEL_LISTA_COMPRAS
  );
};

export const getTiposCarrosseis = (showCommerceModules, variant = "type1") => {
  if (showCommerceModules) {
    return carrossel_types_list[variant] || carrossel_types_list.type1;
  }
  return carrossel_types_list.type2;
};

export const createEmptyConteudoState = () => ({
  tipoCarrosselSelecionado: null,
  categoriaSelecionada: null
});

export const getCategoriaOptions = (setoresFolha = []) =>
  (setoresFolha || []).map(setor => ({
    text: setor.rotulo || setor.descricao || setor.nome,
    value: getSetorId(setor)
  }));

export const getCategoriaLabel = (
  carrossel = {},
  setoresFolha = [],
  conteudoState = {}
) => {
  const categoriaValue =
    getCarouselTypeValue(conteudoState.categoriaSelecionada) ||
    carrossel.idsetor;

  if (!categoriaValue) {
    return "—";
  }

  if (
    conteudoState.categoriaSelecionada &&
    typeof conteudoState.categoriaSelecionada === "object" &&
    conteudoState.categoriaSelecionada.text
  ) {
    return conteudoState.categoriaSelecionada.text;
  }

  const setor = (setoresFolha || []).find(
    item => getSetorId(item) === categoriaValue
  );

  return setor?.rotulo || carrossel.rotulo || categoriaValue;
};

export const hydrateConteudoState = (
  wizardState = {},
  setoresFolha = [],
  variant = "type1"
) => {
  const carrossel = wizardState.carrossel || {};
  const carouselType =
    carrossel.config?.carouselType || carrossel_types.CARROSSEL_PRODUTOS;
  const allTypes = [
    ...carrossel_types_list.type1,
    ...carrossel_types_list.type2
  ];
  const tipoOption = allTypes.find(item => item.value === carouselType) || {
    text: formatCarouselTypeLabel(carouselType, variant),
    value: carouselType
  };

  const categoriaId = carrossel.idsetor;
  let categoriaSelecionada = null;

  if (categoriaId) {
    const setor = (setoresFolha || []).find(
      item => getSetorId(item) === categoriaId
    );
    categoriaSelecionada = setor
      ? {
          text: setor.rotulo || setor.descricao || setor.nome,
          value: categoriaId
        }
      : {
          text: carrossel.rotulo || String(categoriaId),
          value: categoriaId
        };
  }

  wizardState.conteudoState = {
    tipoCarrosselSelecionado: tipoOption,
    categoriaSelecionada
  };

  return wizardState.conteudoState;
};

export const syncConteudoToCarrossel = (
  wizardState = {},
  targetCarrossel = null
) => {
  const carrossel = targetCarrossel || wizardState.carrossel || {};
  const conteudo = wizardState.conteudoState || createEmptyConteudoState();

  if (!carrossel.config) {
    carrossel.config = {};
  }

  const carouselType = getCarouselTypeValue(conteudo.tipoCarrosselSelecionado);
  if (carouselType) {
    carrossel.config.carouselType = carouselType;
  }

  const categoriaId = getCarouselTypeValue(conteudo.categoriaSelecionada);
  carrossel.idsetor = categoriaId || null;
  carrossel.slides = [];

  return carrossel;
};

export const validateStepConteudo = (
  conteudoState = {},
  { showComponente } = {}
) => {
  const carouselType = getCarouselTypeValue(
    conteudoState.tipoCarrosselSelecionado
  );

  if (!carouselType) {
    return {
      valid: false,
      message: "Selecione o tipo de vitrine"
    };
  }

  const categoriaId = getCarouselTypeValue(conteudoState.categoriaSelecionada);
  const exigeCategoria =
    isCarrosselProdutos(carouselType) &&
    !isCarrosselProdutosCliente(carouselType) &&
    typeof showComponente === "function" &&
    showComponente([
      ModulesEnum.COMMERCE_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP
    ]);

  if (exigeCategoria && !categoriaId) {
    return {
      valid: false,
      message: "Vincule essa vitrine de produtos à uma categoria"
    };
  }

  return { valid: true };
};

export const getPreviewImages = (carrossel, limit = 4) => {
  const slides = carrossel?.slides || [];
  return slides
    .filter(slide => slide?.image)
    .slice(0, limit)
    .map(slide => slide.image);
};

export const getBannersCount = carrossel => {
  return (carrossel?.slides || []).filter(slide => slide?.image).length;
};

export const formatBannersLabel = count => {
  const n = Number(count) || 0;
  return n === 1 ? "1 banner" : `${n} banners`;
};

export const getVitrineCategoriaTipoLabel = (carrossel, variant = "type1") => {
  const categoria = carrossel?.rotulo || "—";
  const tipo = formatCarouselTypeLabel(
    carrossel?.config?.carouselType,
    variant
  );
  return `${categoria} · ${tipo}`;
};

export const parseLocaleExibicao = (localexibicao = [], setoresFolha = []) => {
  const locais = Array.isArray(localexibicao) ? localexibicao : [];
  const baseOptions = getLocalExibicaoBaseOptions(setoresFolha).filter(
    o => o.value
  );
  const categoriaOptions = getCategoriaLocalOptions(setoresFolha);

  const categoriaLocals = [];
  const nonCategoriaLocals = [];

  locais.forEach(local => {
    const localValue = normalizeLocalValue(local);
    if (localValue.startsWith("categoria:")) {
      categoriaLocals.push(localValue);
      return;
    }
    nonCategoriaLocals.push(localValue);
  });

  const selectedLocalExibicao = nonCategoriaLocals
    .map(localValue => baseOptions.find(option => option.value === localValue))
    .filter(Boolean);

  if (categoriaLocals.length) {
    const sentinel = baseOptions.find(
      option => option.value === LOCAL_CATEGORIA_SENTINEL
    );
    if (sentinel) {
      selectedLocalExibicao.push(sentinel);
    }
  }

  const selectedCategorias = categoriaLocals
    .map(localValue => {
      const found = categoriaOptions.find(
        option => option.value === localValue
      );
      if (found) {
        return found;
      }

      const categoriaLabel = resolveCategoriaLabel(localValue, setoresFolha);
      if (categoriaLabel) {
        return { text: categoriaLabel, value: localValue };
      }

      return null;
    })
    .filter(Boolean);

  return {
    selectedLocalExibicao,
    selectedCategorias,
    showStaticPages: locais.some(
      local => normalizeLocalValue(local) === "page:static-page"
    ),
    showCategorias: categoriaLocals.length > 0
  };
};

export const buildLocaleExibicao = (
  selectedLocalExibicao = [],
  selectedCategorias = []
) => {
  const baseValues = (selectedLocalExibicao || [])
    .map(item => normalizeLocalValue(item))
    .filter(value => value && value !== LOCAL_CATEGORIA_SENTINEL);

  const categoriaValues = (selectedCategorias || [])
    .map(item => normalizeLocalValue(item))
    .filter(value => value && value.startsWith("categoria:"));

  return [...baseValues, ...categoriaValues];
};

export const NAV_STYLES = [
  { name: "angleDouble", style: "fas fa-angle-double-right" },
  { name: "chevron", style: "fas fa-chevron-right" },
  { name: "carret", style: "fas fa-caret-right" },
  { name: "chevronCircle", style: "fas fa-chevron-circle-right" },
  { name: "arrowCircle", style: "fas fa-arrow-circle-right" }
];

export const NAVIGATION_PRESETS = [
  {
    id: "arrows_dots",
    label: "Setas + Pontos",
    navStyle: "fas fa-chevron-right",
    showDots: true,
    showArrows: true,
    minimalDots: false
  },
  {
    id: "arrows_only",
    label: "Apenas Setas",
    navStyle: "fas fa-chevron-right",
    showDots: false,
    showArrows: true,
    minimalDots: false
  },
  {
    id: "dots_only",
    label: "Apenas Pontos",
    navStyle: "fas fa-chevron-right",
    showDots: true,
    showArrows: false,
    minimalDots: false
  },
  {
    id: "minimal",
    label: "Minimalista",
    navStyle: "fas fa-caret-right",
    showDots: true,
    showArrows: true,
    minimalDots: true
  },
  {
    id: "none",
    label: "Sem Navegação",
    navStyle: "fas fa-chevron-right",
    showDots: false,
    showArrows: false,
    minimalDots: false
  }
];

export const VELOCIDADE_OPTIONS = [
  { text: "Sem transição automática", value: 0 },
  { text: "Conteúdo simples (4 seg)", value: 4000 },
  { text: "Conteúdo moderado (5 seg)", value: 5000 },
  { text: "Conteúdo complexo (6 seg)", value: 6000 },
  { text: "Conteúdo longo (8 seg)", value: 8000 },
  { text: "Conteúdo muito longo (10 seg)", value: 10000 }
];

export const TRANSICAO_OPTIONS = [
  { text: "Deslizar lateralmente", value: false },
  { text: "Aparecer suavemente (1 por vez)", value: true }
];

export const USER_LOGIN_TYPE_OPTIONS = [
  { text: "Apenas usuários logados", value: "LOGADOS" },
  { text: "Apenas usuários deslogados", value: "DESLOGADOS" },
  { text: "Ambos", value: "AMBOS" }
];

export const resolveNavigationPreset = (config = {}) => {
  const showArrows = config.showArrows !== false;
  const showDots = config.showDots !== false;
  const minimalDots = config.minimalDots === true;

  if (!showArrows && !showDots) {
    return NAVIGATION_PRESETS.find(p => p.id === "none");
  }
  if (!showArrows && showDots) {
    return NAVIGATION_PRESETS.find(p => p.id === "dots_only");
  }
  if (showArrows && !showDots) {
    return NAVIGATION_PRESETS.find(p => p.id === "arrows_only");
  }
  if (minimalDots) {
    return NAVIGATION_PRESETS.find(p => p.id === "minimal");
  }
  return NAVIGATION_PRESETS.find(p => p.id === "arrows_dots");
};

export const applyNavigationPreset = (presetId, config = {}) => {
  const preset =
    NAVIGATION_PRESETS.find(p => p.id === presetId) || NAVIGATION_PRESETS[0];

  config.navStyle = preset.navStyle;
  config.showDots = preset.showDots;
  config.showArrows = preset.showArrows;
  config.minimalDots = preset.minimalDots;

  return config;
};

export const resolveNavStyleFromConfig = navStyle => {
  return NAV_STYLES.find(s => s.style === navStyle) || NAV_STYLES[1];
};

export const createEmptyAppearanceState = () => ({
  navigationPreset: "arrows_dots",
  selectedNavStyle: NAV_STYLES[1],
  autoplaySpeed: 5000,
  autoplayEnabled: true,
  fade: false,
  centerMode: false,
  showTitle: false,
  ordem: "lista-produtos:1",
  selectedDevice: {
    mobile: true,
    desktop: true,
    fidelidade: false
  },
  slidesToShowResponsive: {
    desktop: 3,
    mobile: 1,
    fidelidade: 1
  },
  userLoginType: "AMBOS",
  segmentoClienteSelecionado: null
});

export const hydrateAppearanceState = (carrossel = {}) => {
  const config = carrossel.config || {};
  const devices = carrossel.device || ["desktop", "mobile"];
  const slidesToShow = config.slidesToShowResponsive || {
    desktop: 3,
    mobile: 1,
    fidelidade: 1
  };

  const autoplaySpeed =
    config.autoplaySpeed != null ? config.autoplaySpeed : 5000;
  const autoplayEnabled =
    config.autoplay != null ? config.autoplay : autoplaySpeed > 0;

  const resolvedConfig = {
    ...config,
    showArrows: config.showArrows ?? config.arrows,
    showDots: config.showDots,
    minimalDots: config.minimalDots
  };

  if (
    config.showArrows == null &&
    config.arrows == null &&
    config.showDots == null
  ) {
    resolvedConfig.showDots = config.showDots !== false;
    resolvedConfig.showArrows = true;
  }

  const preset = resolveNavigationPreset(resolvedConfig);

  return {
    navigationPreset: preset.id,
    selectedNavStyle: resolveNavStyleFromConfig(config.navStyle),
    autoplaySpeed,
    autoplayEnabled,
    fade: config.fade === true,
    centerMode: config.centerMode === true,
    showTitle: config.showTitle === true,
    ordem: `${carrossel.area_pagina ||
      "lista-produtos"}:${carrossel.ordem_area || 1}`,
    selectedDevice: {
      mobile: devices.indexOf("mobile") >= 0,
      desktop: devices.indexOf("desktop") >= 0,
      fidelidade: devices.indexOf("fidelidade") >= 0
    },
    slidesToShowResponsive: {
      desktop: Number(slidesToShow.desktop) || 3,
      mobile: Number(slidesToShow.mobile) || 1,
      fidelidade: Number(slidesToShow.fidelidade) || 1
    },
    userLoginType: config.userLoginType || "AMBOS",
    segmentoClienteSelecionado: null
  };
};

export const syncAppearanceToCarrossel = (appearance = {}, carrossel = {}) => {
  if (!carrossel.config) {
    carrossel.config = {};
  }

  const config = carrossel.config;
  applyNavigationPreset(appearance.navigationPreset, config);

  config.autoplaySpeed = appearance.autoplayEnabled
    ? Number(appearance.autoplaySpeed) || 0
    : 0;
  config.autoplay = appearance.autoplayEnabled && config.autoplaySpeed > 0;
  config.fade = appearance.fade === true;
  config.centerMode = appearance.centerMode === true;
  config.centerPadding = appearance.centerMode ? "60px" : null;
  config.showTitle = appearance.showTitle === true;
  config.userLoginType = appearance.userLoginType || "AMBOS";

  if (!config.colors) {
    config.colors = { font: "#000000FF", background: "" };
  }

  config.slidesToShowResponsive = {
    desktop: Number(appearance.slidesToShowResponsive?.desktop) || 3,
    mobile: Number(appearance.slidesToShowResponsive?.mobile) || 1,
    fidelidade: Number(appearance.slidesToShowResponsive?.fidelidade) || 1
  };

  const devices = [];
  if (appearance.selectedDevice?.desktop) {
    devices.push("desktop");
  }
  if (appearance.selectedDevice?.mobile) {
    devices.push("mobile");
  }
  if (appearance.selectedDevice?.fidelidade) {
    devices.push("fidelidade");
  }
  carrossel.device = devices;

  if (appearance.ordem) {
    const parts = String(appearance.ordem).split(":");
    carrossel.area_pagina = parts[0] || "lista-produtos";
    carrossel.ordem_area = Number(parts[1]) || 1;
  }

  if (appearance.selectedNavStyle?.style) {
    config.navStyle = appearance.selectedNavStyle.style;
  }

  return carrossel;
};

export const syncPublicoToCarrossel = (wizardState = {}) => {
  const carrossel = wizardState.carrossel || {};
  if (!carrossel.config) {
    carrossel.config = {};
  }

  const segmento = wizardState.segmentoClienteSelecionado;
  if (segmento && typeof segmento === "object" && segmento.value) {
    carrossel.idsegmentocliente = segmento.value;
  } else if (segmento) {
    carrossel.idsegmentocliente = segmento;
  } else {
    carrossel.idsegmentocliente = null;
  }

  carrossel.config.userLoginType =
    wizardState.appearanceState?.userLoginType ||
    carrossel.config.userLoginType ||
    "AMBOS";

  return carrossel;
};

export const hydratePublicoState = (carrossel = {}, segmentosCliente = []) => {
  const segmento =
    (segmentosCliente || []).find(
      s => s.value === carrossel.idsegmentocliente
    ) || null;

  return {
    segmentoClienteSelecionado: segmento,
    userLoginType: carrossel.config?.userLoginType || "AMBOS",
    showOnPesquisaAtivada: carrossel.config?.showOnPesquisaAtivada === true
  };
};

export const getVelocidadeLabel = value => {
  const found = VELOCIDADE_OPTIONS.find(o => o.value === value);
  return found ? found.text : "Sem transição automática";
};

export const getTransicaoLabel = fade => {
  const found = TRANSICAO_OPTIONS.find(o => o.value === fade);
  return found ? found.text : "Deslizar lateralmente";
};

export const getUserLoginTypeLabel = value => {
  const found = USER_LOGIN_TYPE_OPTIONS.find(o => o.value === value);
  return found ? found.text : "Ambos";
};

export const getNavigationPresetLabel = presetId => {
  const found = NAVIGATION_PRESETS.find(p => p.id === presetId);
  return found ? found.label : "Setas + Pontos";
};

export const getDevicesSummary = (appearance = {}) => {
  const parts = [];
  if (appearance.selectedDevice?.desktop) {
    const qty = appearance.slidesToShowResponsive?.desktop || 3;
    parts.push(`Desktop: ${qty} banner${qty > 1 ? "s" : ""}`);
  }
  if (appearance.selectedDevice?.mobile) {
    const qty = appearance.slidesToShowResponsive?.mobile || 1;
    parts.push(`Mobile: ${qty} banner${qty > 1 ? "s" : ""}`);
  }
  return parts.length ? parts.join(" • ") : "Nenhum dispositivo";
};

export const validateStepPublico = () => ({
  valid: true
});

export const validateStepAparencia = (appearance = {}) => {
  const desktop = appearance.selectedDevice?.desktop;
  const mobile = appearance.selectedDevice?.mobile;
  const fidelidade = appearance.selectedDevice?.fidelidade;

  if (!desktop && !mobile && !fidelidade) {
    return {
      valid: false,
      message: "Selecione ao menos um dispositivo"
    };
  }

  if (appearance.navigationPreset === "none" && !appearance.autoplayEnabled) {
    return {
      valid: false,
      message: "Sem navegação exige exibição automática ativa"
    };
  }

  if (
    appearance.autoplayEnabled &&
    (!appearance.autoplaySpeed || appearance.autoplaySpeed <= 0)
  ) {
    return {
      valid: false,
      message:
        "Selecione a velocidade quando a exibição automática estiver ativa"
    };
  }

  const slidesToShow = appearance.slidesToShowResponsive || {};
  if (desktop && Number(slidesToShow.desktop) < 1) {
    return {
      valid: false,
      message: "Informe ao menos 1 banner visível para desktop"
    };
  }
  if (mobile && Number(slidesToShow.mobile) < 1) {
    return {
      valid: false,
      message: "Informe ao menos 1 banner visível para mobile"
    };
  }
  if (fidelidade && Number(slidesToShow.fidelidade) < 1) {
    return {
      valid: false,
      message: "Informe ao menos 1 banner visível para fidelidade"
    };
  }

  return { valid: true };
};

export const buildReviewSummary = (
  wizardState = {},
  setoresFolha = [],
  segmentosCliente = [],
  paginasEstaticas = [],
  options = {}
) => {
  const carrossel = wizardState.carrossel || {};
  const config = carrossel.config || {};
  const appearance = wizardState.appearanceState || {};
  const variant = options.variant || "type1";
  const isProductCategory =
    (wizardState.tipoConteudo || carrossel.tipo_conteudo) ===
    "PRODUCT_CATEGORY";

  const segmento =
    wizardState.segmentoClienteSelecionado ||
    (segmentosCliente || []).find(s => s.value === carrossel.idsegmentocliente);

  const staticPages = (wizardState.presentOnStaticPage || []).map(id => {
    const page = (paginasEstaticas || []).find(
      p => p.idconteudoestatico === id
    );
    return page ? page.titulo : id;
  });

  const summary = {
    informacoes: {
      titulo: carrossel.titulo || "—",
      local: formatLocalExibicao(
        buildLocaleExibicao(
          wizardState.selectedLocalExibicao,
          wizardState.selectedCategorias
        ),
        setoresFolha
      ),
      vigencia: formatVigencia(
        carrossel.inicio_vigencia,
        carrossel.fim_vigencia
      ),
      paginasEstaticas: staticPages.length ? staticPages.join(", ") : null
    },
    banners: {
      count: getBannersCount(carrossel),
      images: getPreviewImages(carrossel, 6),
      programacoes: (carrossel.slides || [])
        .filter(slide => slide?.image)
        .map((slide, indice) => ({
          indice,
          label: `Banner ${indice + 1}`,
          programacao: formatarProgramacaoRevisao(slide.programacao)
        }))
    },
    publico: {
      segmento: segmento?.text || "Todos os segmentos",
      userLoginType: getUserLoginTypeLabel(
        appearance.userLoginType || config.userLoginType
      ),
      showOnPesquisaAtivada: config.showOnPesquisaAtivada ? "Sim" : "Não"
    },
    aparencia: {
      dispositivos: getDevicesSummary(appearance),
      navegacao: getNavigationPresetLabel(appearance.navigationPreset),
      velocidade: appearance.autoplayEnabled
        ? getVelocidadeLabel(appearance.autoplaySpeed)
        : "Desativada",
      transicao: getTransicaoLabel(appearance.fade),
      autoplay: appearance.autoplayEnabled ? "Ativo" : "Inativo",
      corFonte: config.colors?.font || "#000000FF",
      centerMode: config.centerMode ? "Sim" : "Não",
      fixedTop: config.fixedTop ? "Sim" : "Não",
      showTitle: config.showTitle ? "Sim" : "Não",
      bannerPrincipal: config.bannerPrincipal ? "Sim" : "Não"
    },
    status: carrossel.ativo ? "Ativo" : "Inativo"
  };

  if (isProductCategory) {
    summary.conteudo = {
      tipo: formatCarouselTypeLabel(config.carouselType, variant),
      categoria: getCategoriaLabel(
        carrossel,
        setoresFolha,
        wizardState.conteudoState || {}
      )
    };
  }

  return summary;
};

export const getWizardSteps = tipoConteudo => {
  const isStatic = tipoConteudo === "STATIC_IMAGES";

  if (isStatic) {
    return [
      {
        id: 1,
        label: "Informações básicas",
        subtitle: "Nome, local e período de exibição",
        enabled: true
      },
      {
        id: 2,
        label: "Banners e ações",
        subtitle: "Imagens, ordem e destino do clique",
        enabled: true
      },
      {
        id: 3,
        label: "Público",
        subtitle: "Segmentação de usuários",
        enabled: true
      },
      {
        id: 4,
        label: "Aparência",
        subtitle: "Estilo e comportamento do carrossel",
        enabled: true
      },
      {
        id: 5,
        label: "Revisão",
        subtitle: "Confira tudo antes de publicar",
        enabled: true
      }
    ];
  }

  return [
    {
      id: 1,
      label: "Informações básicas",
      subtitle: "Nome, local e período de exibição",
      enabled: true
    },
    {
      id: 2,
      label: "Conteúdo",
      subtitle: "Tipo de vitrine e produtos exibidos",
      enabled: true
    },
    {
      id: 3,
      label: "Público",
      subtitle: "Segmentação de usuários",
      enabled: true
    },
    {
      id: 4,
      label: "Aparência",
      subtitle: "Estilo e comportamento do carrossel",
      enabled: true
    },
    {
      id: 5,
      label: "Revisão",
      subtitle: "Confira tudo antes de publicar",
      enabled: true
    }
  ];
};

export const createEmptyWizardCarrossel = (tipoConteudo = "STATIC_IMAGES") => ({
  titulo: "",
  inicio_vigencia: null,
  fim_vigencia: null,
  localexibicao: [],
  slides: [],
  config: {
    presentOnStaticPage: [],
    autoplay: true,
    autoplaySpeed: 5000,
    fade: false,
    navStyle: "fas fa-chevron-right",
    showDots: true,
    showArrows: true,
    minimalDots: false,
    centerMode: false,
    showTitle: false,
    fixedTop: false,
    bannerPrincipal: false,
    showOnPesquisaAtivada: false,
    userLoginType: "AMBOS",
    colors: { font: "#000000FF", background: "" },
    slidesToShowResponsive: { desktop: 3, mobile: 1, fidelidade: 1 },
    ...(tipoConteudo === "PRODUCT_CATEGORY"
      ? { carouselType: carrossel_types.CARROSSEL_PRODUTOS }
      : {})
  },
  device: ["desktop", "mobile"],
  ativo: false,
  tipo_conteudo: tipoConteudo,
  area_pagina: "lista-produtos",
  ordem_area: 1,
  idsegmentocliente: null,
  idsetor: null
});

export const getSlideImageUrl = (slide, revisions = {}) => {
  if (!slide?.image) return "";
  const base = String(slide.image).split("?")[0];
  const revision = revisions[slide.id];
  return revision ? `${base}?v=${revision}` : base;
};

export const resolveCategoriaOptionId = rawValue => {
  if (!rawValue) return "";
  const value = String(rawValue).split("|")[0];
  if (value.startsWith("categoria:")) {
    return value;
  }
  return value ? `categoria:${value}` : "";
};

export const CARROSSEL_NAVIGATION_PAGES = [
  { descricao: "Página inicial da loja", value: "page-home" },
  { descricao: "Login", value: "page-login" },
  { descricao: "Cadastro", value: "page-cadastro" },
  { descricao: "Carrinho", value: "page-carrinho" }
];

export const getNavigationPages = () =>
  CARROSSEL_NAVIGATION_PAGES.map(page => ({ ...page }));

export const findNavigationPage = (paginasNavegacao = [], value) => {
  if (!value) return null;
  const pages = paginasNavegacao?.length
    ? paginasNavegacao
    : CARROSSEL_NAVIGATION_PAGES;
  return pages.find(page => page.value === value) || null;
};

export const resolveActionTypeFromSlide = (slideAction = {}) => {
  const { type, params = [] } = slideAction;
  if (!type || type === "nothing") return "nothing";
  if (type === "filter" && params[0]) return `filter:${params[0]}`;
  if (type === "link" && params[0]) return `link:${params[0]}`;
  return type;
};

export const findCategoriaNavigationTarget = (
  categoriaOptions = [],
  rawParam
) => {
  const optionId = resolveCategoriaOptionId(rawParam);
  if (!optionId) return null;

  const option = categoriaOptions.find(item => item.value === optionId);
  if (option) {
    return { id: option.value, nome: option.text };
  }

  const suffix = optionId.replace(/^categoria:/, "");
  const fallback = categoriaOptions.find(
    item =>
      item.value === optionId ||
      item.value === `categoria:${suffix}` ||
      item.value.endsWith(`:${suffix}`)
  );

  return fallback ? { id: fallback.value, nome: fallback.text } : null;
};

export const hasValidSlideActionParams = action => {
  if (!action || action.type === "nothing") return true;
  const params = action.params || [];

  switch (action.type) {
    case "filter":
      return Boolean(resolveCategoriaOptionId(params[1]));
    case "static-page":
      return Boolean(params[0]);
    case "page-selection":
      return Boolean(params[0]);
    case "product":
      return Boolean(params[0]);
    case "combination":
      return Boolean(params[0]) || params[2] === false;
    case "link":
      return Boolean(params[1]);
    default:
      return true;
  }
};

export const mergeSlidesPreservingActions = (
  currentSlides = [],
  nextSlides = []
) => {
  if (!Array.isArray(nextSlides) || !nextSlides.length) {
    return currentSlides;
  }

  const currentById = new Map(
    (currentSlides || [])
      .filter(slide => slide?.id)
      .map(slide => [slide.id, slide])
  );

  return nextSlides.map(slide => {
    const current = currentById.get(slide?.id);
    const programacao = mergeProgramacaoSlide(current, slide);

    if (!current?.action) {
      return programacao ? { ...slide, programacao } : slide;
    }

    const nextAction = slide?.action;
    const shouldKeepCurrentAction =
      !nextAction ||
      nextAction.type === "nothing" ||
      !hasValidSlideActionParams(nextAction);

    if (!shouldKeepCurrentAction) {
      return programacao ? { ...slide, programacao } : slide;
    }

    return {
      ...slide,
      action: current.action,
      ...(programacao ? { programacao } : {})
    };
  });
};

export const BANNER_IRREVERSIBLE_MESSAGES = {
  remove: {
    title: "Remover banner",
    text:
      "Esta ação remove o banner imediatamente. Não será possível desfazer, mesmo cancelando a edição do carrossel."
  }
};

export const BANNER_REPLACE_SAVE_MESSAGE = {
  title: "Substituir imagem",
  text:
    "Para manter a nova imagem, salve o passo do carrossel. Se cancelar a edição antes de salvar, a imagem anterior será restaurada."
};

export const CANCEL_WITH_IRREVERSIBLE_BANNER_MESSAGE = {
  title: "Alterações não salvas",
  text:
    "Existem alterações não salvas. Banners removidos não podem ser recuperados ao cancelar. Deseja sair mesmo assim?"
};

export const hasIrreversibleBannerChanges = (
  _wizardState,
  sessionDeletedSlideIds = []
) => {
  return (sessionDeletedSlideIds || []).length > 0;
};

export const cloneWizardSnapshot = wizardState => {
  if (!wizardState) return null;

  return JSON.parse(
    JSON.stringify({
      tipoConteudo: wizardState.tipoConteudo,
      selectedLocalExibicao: wizardState.selectedLocalExibicao,
      showStaticPages: wizardState.showStaticPages,
      presentOnStaticPage: wizardState.presentOnStaticPage,
      showCategorias: wizardState.showCategorias,
      selectedCategorias: wizardState.selectedCategorias,
      segmentoClienteSelecionado: wizardState.segmentoClienteSelecionado,
      slideImageRevisions: wizardState.slideImageRevisions,
      conteudoState: wizardState.conteudoState,
      appearanceState: wizardState.appearanceState,
      carrossel: wizardState.carrossel
    })
  );
};

export const restoreWizardFromSnapshot = (wizardState, snapshot) => {
  if (!wizardState || !snapshot) return;

  wizardState.tipoConteudo = snapshot.tipoConteudo;
  wizardState.selectedLocalExibicao = snapshot.selectedLocalExibicao || [];
  wizardState.showStaticPages = snapshot.showStaticPages;
  wizardState.presentOnStaticPage = snapshot.presentOnStaticPage || [];
  wizardState.showCategorias = snapshot.showCategorias;
  wizardState.selectedCategorias = snapshot.selectedCategorias || [];
  wizardState.segmentoClienteSelecionado = snapshot.segmentoClienteSelecionado;
  wizardState.slideImageRevisions = snapshot.slideImageRevisions || {};
  wizardState.conteudoState = snapshot.conteudoState;
  wizardState.appearanceState = snapshot.appearanceState;
  wizardState.carrossel = JSON.parse(JSON.stringify(snapshot.carrossel || {}));
};

export const buildRollbackPayload = (snapshot, sessionDeletedSlideIds = []) => {
  if (!snapshot) return null;

  const deletedIds = new Set((sessionDeletedSlideIds || []).filter(Boolean));
  const rollbackSnapshot = cloneWizardSnapshot(snapshot);

  if (rollbackSnapshot?.carrossel) {
    rollbackSnapshot.carrossel.slides = (
      rollbackSnapshot.carrossel.slides || []
    ).filter(slide => slide?.id && !deletedIds.has(slide.id));
  }

  return buildCarrosselPayload(rollbackSnapshot);
};

export const mergeSlidesAfterServerChange = (
  currentSlides = [],
  serverSlides = []
) => {
  if (!Array.isArray(serverSlides) || !serverSlides.length) {
    return currentSlides || [];
  }

  const currentIds = new Set(
    (currentSlides || []).map(slide => slide?.id).filter(Boolean)
  );
  const serverById = new Map(
    serverSlides.filter(slide => slide?.id).map(slide => [slide.id, slide])
  );

  const updatedCurrent = (currentSlides || [])
    .filter(slide => slide?.id && serverById.has(slide.id))
    .map(slide => {
      const merged = mergeSlidesPreservingActions(
        [slide],
        [serverById.get(slide.id)]
      );
      return merged[0] || slide;
    });

  const newSlides = serverSlides.filter(
    slide => slide?.id && !currentIds.has(slide.id)
  );

  return [...updatedCurrent, ...newSlides];
};

export const validateStepBanners = (slides = [], vigencia = {}) => {
  const withImage = (slides || []).filter(slide => slide?.image);
  if (!withImage.length) {
    return {
      valid: false,
      message: "Adicione ao menos um banner ao carrossel"
    };
  }

  return validarProgramacaoSlides(slides, vigencia);
};

export const mergeCreatedCarrosselIntoWizard = (localCarrossel, created) => ({
  ...localCarrossel,
  ...created,
  inicio_vigencia: localCarrossel.inicio_vigencia ?? created.inicio_vigencia,
  fim_vigencia: localCarrossel.fim_vigencia ?? created.fim_vigencia,
  config: {
    ...(localCarrossel.config || {}),
    ...(created.config || {})
  }
});

export const buildCarrosselPayload = wizardState => {
  const sourceCarrossel = wizardState.carrossel || {};
  let carrossel = {
    ...sourceCarrossel,
    slides: JSON.parse(JSON.stringify(sourceCarrossel.slides || [])),
    config: JSON.parse(JSON.stringify(sourceCarrossel.config || {}))
  };

  syncPublicoToCarrossel(wizardState);

  if (wizardState.appearanceState) {
    syncAppearanceToCarrossel(wizardState.appearanceState, carrossel);
  }

  if (
    (wizardState.tipoConteudo || carrossel.tipo_conteudo) === "PRODUCT_CATEGORY"
  ) {
    carrossel = syncConteudoToCarrossel(wizardState, carrossel);
  }

  const localexibicao = buildLocaleExibicao(
    wizardState.selectedLocalExibicao,
    wizardState.selectedCategorias
  );

  if (wizardState.appearanceState?.userLoginType) {
    carrossel.config.userLoginType = wizardState.appearanceState.userLoginType;
  }

  const tipoConteudo = wizardState.tipoConteudo || carrossel.tipo_conteudo;
  if (tipoConteudo === "STATIC_IMAGES") {
    carrossel.slides = (carrossel.slides || []).map(slide => ({
      ...slide,
      programacao: montarProgramacaoPayload(slide.programacao)
    }));
  }

  return {
    ...carrossel,
    titulo: (carrossel.titulo || "").trim(),
    localexibicao,
    tipo_conteudo: wizardState.tipoConteudo || carrossel.tipo_conteudo,
    config: {
      ...(carrossel.config || {}),
      presentOnStaticPage:
        wizardState.presentOnStaticPage ||
        carrossel.config?.presentOnStaticPage ||
        []
    }
  };
};

export const getListagemLabels = tipoConteudo => {
  const isStatic = tipoConteudo === "STATIC_IMAGES";

  if (isStatic) {
    return {
      titulo: "Gestão de Carrosséis",
      subtitulo: "Crie, edite e gerencie os carrosséis exibidos no site.",
      botaoNovo: "Novo carrossel",
      placeholderBusca: "Buscar carrossel...",
      itemSingular: "carrossel",
      itemPlural: "carrosséis",
      confirmarExclusaoTitulo: "Apagar esse carrossel?",
      bloqueioExclusaoAtivoTitulo: "O Carrossel está ativo?",
      bloqueioExclusaoAtivoTexto: "Inative o carrossel para exclusão",
      confirmarDuplicacaoTitulo: "Duplicar esse carrossel?",
      confirmarDuplicacaoTexto:
        "Será criada uma cópia inativa com as mesmas configurações.",
      duplicacaoSucesso: "Carrossel duplicado com sucesso.",
      duplicacaoErro: "Erro ao duplicar carrossel.",
      confirmarAtivacaoTitulo: "Ativar esse carrossel?",
      confirmarAtivacaoTexto:
        "O carrossel passará a ser exibido conforme vigência e locais configurados.",
      confirmarDesativacaoTitulo: "Desativar esse carrossel?",
      confirmarDesativacaoTexto:
        "O carrossel deixará de ser exibido no site até ser ativado novamente.",
      ativacaoSucesso: "Carrossel ativado com sucesso.",
      desativacaoSucesso: "Carrossel desativado com sucesso.",
      ativacaoErro: "Erro ao ativar carrossel.",
      desativacaoErro: "Erro ao desativar carrossel.",
      ativacaoSemBannerErro:
        "Adicione ao menos um banner antes de ativar o carrossel.",
      menuAtivar: "Ativar",
      menuDesativar: "Desativar",
      menuExcluir: "Excluir"
    };
  }

  return {
    titulo: "Gestão de Vitrines",
    subtitulo:
      "Crie, edite e gerencie as vitrines de produtos exibidas no site.",
    botaoNovo: "Nova vitrine",
    placeholderBusca: "Buscar vitrine...",
    itemSingular: "vitrine",
    itemPlural: "vitrines",
    confirmarExclusaoTitulo: "Apagar essa vitrine?",
    bloqueioExclusaoAtivoTitulo: null,
    bloqueioExclusaoAtivoTexto: null,
    confirmarDuplicacaoTitulo: "Duplicar essa vitrine?",
    confirmarDuplicacaoTexto:
      "Será criada uma cópia inativa com as mesmas configurações.",
    duplicacaoSucesso: "Vitrine duplicada com sucesso.",
    duplicacaoErro: "Erro ao duplicar vitrine.",
    confirmarAtivacaoTitulo: "Ativar essa vitrine?",
    confirmarAtivacaoTexto:
      "A vitrine passará a ser exibida conforme vigência e locais configurados.",
    confirmarDesativacaoTitulo: "Desativar essa vitrine?",
    confirmarDesativacaoTexto:
      "A vitrine deixará de ser exibida no site até ser ativada novamente.",
    ativacaoSucesso: "Vitrine ativada com sucesso.",
    desativacaoSucesso: "Vitrine desativada com sucesso.",
    ativacaoErro: "Erro ao ativar vitrine.",
    desativacaoErro: "Erro ao desativar vitrine.",
    ativacaoSemBannerErro: null,
    menuAtivar: "Ativar",
    menuDesativar: "Desativar",
    menuExcluir: "Excluir"
  };
};
